<template>
  <div class="zcqd-con">
    <img src="../../../assets/image/kjqg/zcqdkc/czqdkc-banner.png" class="zcqd-banner">
    <div class="xskj-con">
      <div class="xskj-title" ref="xskj"></div>
      <div class="xskj-top">
        <div class="video-con">
          <div class="video" v-html="videoHtml"></div>
          <div class="video-title">{{videoTitle}}</div>
        </div>
        <div class="top-con">
          <swiper ref="xskjSwiper" :options="xskjSwiper" v-if="xskjTopList.length > 0">
            <!-- <swiper ref="xskjSwiper" :options="xskjSwiper" v-if="xskjList.length > 0"> -->
            <swiperSlide v-for="(item,ind) in xskjTopList" :key="ind">
              <div class="item-cover" :style="{ backgroundImage: item.cover ? `url(${item.cover})` : '',}"></div>
            </swiperSlide>
          </swiper>
          <div class="swiper-button-next xskj"></div>
          <div class="swiper-button-prev xskj"></div>
        </div>
      </div>
      <div class="xskj-list">
        <div class="xskj-item" v-for="item,ind in xskjList" :key="item.id" :class="{hide: ind > 3 && xskjPage == 2 }" @click="showVideo(item)">
          <div class="item-img">
            <div :style="`background-image: url(${item.cover})`"></div>
          </div>
          <div class="item-title">
            <div class="title-text">{{item.title}}</div>
          </div>
        </div>
        <div class="bnkj-empty"></div>
        <div class="bnkj-empty"></div>
        <div class="bnkj-empty"></div>
      </div>
      <div class="xskj-more" @click="showMore()" v-if="xskjPage < xskjPageNum || xskjPage == 2 && xskjList.length > 4">显示更多</div>
    </div>
    <div class="zcyg-con">
      <div class="zcyg-title" ref="zcyg"></div>
      <div class="zcyg-main">
        <div class="main-con">
          <div class="zcyg-categroy">
            <div class="categroy-item" v-for="item,ind in zcygCategroy" :key="ind" :class="{active: item.title == zcygaActiveTitle}" @click="setzcygList(item)">
              <div class="item-text">{{item.realTitle}}</div>
            </div>
          </div>
          <div class="zcyg-list">
            <div class="zcyg-item" v-for="item,ind in zcygList" :key="ind" @click="toDetail(item)">
              <div class="item-time">{{item.abstract}}</div>
              <div class="item-title">{{item.title}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="spin-con" v-if="loading">
      <a-spin>
        <a-icon slot="indicator" type="loading" style="font-size: 24px" spin />
      </a-spin>
    </div>
    <videoModal :videoShow="videoShow" :videoInfo="videoInfo" :videoTitle="videoInfo.title" @closeModal="videoShow = false"></videoModal>

  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import services from "../../../assets/js/services";
import utils from "../../../assets/js/utils";
import { mapActions } from "vuex";
import videoModal from "../components/video-modal.vue";
export default {
  components: {
    videoModal,
    swiper, swiperSlide,
  },
  async created() {
    let res = await this.getAppsLoginUserInfo();
    this.isChrome = utils.bowerUserAgent();
    if (res.code != "0000") {
      this.$message.info("请先登录！");
      this.$router.push({ path: `/${this.school_code}/kjqg/kjqgIndex` });
    }
    this.getxskjTopList()
    this.getzcygList()
  },
  mounted() {
    if (this.$route.query.ind) {
      if (this.$route.query.ind == 0) {
        window.scrollTo(0, this.$refs.xskj.offsetTop - 120)
      }
      if (this.$route.query.ind == 1) {
        window.scrollTo(0, this.$refs.zcyg.offsetTop - 120)
      }
    }
  },
  data() {
    let self = this;
    return {
      specialId: services.KJQG_SPECIAL_ID,
      school_code: localStorage.getItem("schoolCode"),
      activeId: "",
      videoHtml: '',
      activePlaying: {},
      clickState: false,
      loading: false,
      xskjSwiper: {
        direction: "vertical",
        slidesPerView: 3,
        spaceBetween: 16,
        slideActiveClass: 'active', // 活动块的className
        loop: true,
        loopAdditionalSlides: 0,
        slideToClickedSlide: true,
        autoplayDisableOnInteraction: false,
        autoplay: {
          delay: 5000,
          // pauseOnMouseEnter: true,
          disableOnInteraction: false
        },
        navigation: {
          // 前进后退按钮 ,不同版本配置方式不同
          nextEl: `.swiper-button-next.xskj`,
          prevEl: `.swiper-button-prev.xskj`,
        },
        on: {
          slideChange: function () {
            self.activeItem = self.xskjTopList[this.realIndex]
            self.$nextTick(() => {
              self.setVideo(self.activeItem)
            })

          },
          click: function () {
            self.clickState = true

          }
        },
      },
      xskjTopList: [],
      videoTitle: "",
      xskjPage: 1,
      xskjSize: 9,
      xskjPageNum: 0,
      xskjList: [],
      zcygCategroy: [{
        title: "新时代科技强国 战略阶段",
        realTitle: "新时代科技强国战略阶段-（2020 - 至今）"
      },
      {
        title: "自主创新 战略阶段",
        realTitle: "自主创新战略阶段（2006 - 2019）"
      },
      {
        title: "科教兴国 战略阶段",
        realTitle: "科教兴国战略阶段（1992 - 2005）"
      },
      {
        title: "商品经济时代 改革阶段",
        realTitle: "商品经济时代的改革阶段（1977 - 1991）"
      },
      {
        title: "计划经济时代 探索阶段",
        realTitle: "计划经济时代的探索阶段（1949 - 1976）"
      },],
      zcygaActiveTitle: "新时代科技强国 战略阶段",
      zcygList: [],
      videoShow: false,
      videoInfo: {}
    }
  },
  watch: {
    "clickState": {
      handler(newVal) {
        if (newVal && this.activePlaying) {
          this.activePlaying.play()
          this.$refs.xskjSwiper.swiper.autoplay.stop()
          this.clickState = false
        }
      },
    },

  },
  methods: {
    ...mapActions(["goAppsDetailsBeforeLogin", "getAppsLoginUserInfo"]),
    async getxskjTopList() {
      let res = await services.getAreaSzztkLists({
        page: 1,
        length: this.xskjSize,
        count: 0,
        school_code: this.school_code,
        special_id: this.specialId,
        kind: "1",
        is_video: 1,
        column_name: "习说科技",
        order_by: "asc"
      })
      if (res.code == "0000" && res.data.items) {
        this.xskjTopList = res.data.items
        this.xskjPageNum = res.data.page_num
        if (res.data.page_num > 1) {
          this.xskjPage = 2
          this.getxskjList()
        }
        this.$nextTick(() => {
          this.setVideo(this.xskjTopList[0])
        })
      }
    },
    async getxskjList() {
      this.loading = true
      if (this.xskjPage > this.xskjPageNum) {
        this.loading = false
        return
      }
      let res = await services.getAreaSzztkLists({
        page: this.xskjPage,
        length: this.xskjSize,
        count: 0,
        school_code: this.school_code,
        special_id: this.specialId,
        kind: "1",
        is_video: 1,
        column_name: "习说科技",
        order_by: "asc"
      })
      if (res.code == "0000" && res.data.items) {
        this.xskjList.push(...res.data.items)
        this.xskjPageNum = res.data.page_num
      }
      this.loading = false

    },
    showMore() {
      this.xskjPage = this.xskjPage + 1
      this.getxskjList()
    },
    async getzcygList() {
      this.loading = true
      let res = await services.getAreaSzztkLists({
        page: 1,
        length: 10,
        count: 0,
        school_code: this.school_code,
        special_id: this.specialId,
        kind: "1",
        column_name: this.zcygaActiveTitle,
        order_by: "asc"
      })
      if (res.code == "0000" && res.data.items) {
        this.zcygList = res.data.items
      } else {
        this.zcygList = []
      }
      this.loading = false
    },
    setzcygList(item) {
      this.zcygaActiveTitle = item.title
      this.getzcygList()
    },
    setVideo(item) {
      this.videoTitle = item.title
      if (item.tencent_vod_file_id && item.tencent_vod_app_id) {
        this.videoHtml = `<video id="v-${item.tencent_vod_file_id}" :data-fileid="${item.tencent_vod_file_id}"
                :data-appid="${item.tencent_vod_app_id}" style="width: 100%;height: 100%;"></video>`
        this.$nextTick(() => {
          this.initVideoFile(`v-${item.tencent_vod_file_id}`, item.tencent_vod_file_id, item.tencent_vod_app_id)
        })
      } else {
        this.videoHtml = `<div class="img-cover" style="background-image: url('${item.cover}'); background-size: cover;background-position: center;width: 100%; height: 100%;"></div>`
      }
    },
    initVideoFile(elemId, qclude_id, appId) {

      utils.loadScript(
        window.location.origin + "/vod/hls.min.0.12.4.js",
        () => {
          utils.loadScript(
            window.location.origin + "/vod/tcplayer.min.js",
            () => {
              if (typeof window.TCPlayer === "function") {
                this.activePlaying = window.TCPlayer(elemId, {
                  // player-container-id 为播放器容器ID，必须与html中一致
                  fileID: qclude_id, // 请传入需要播放的视频filID 必须
                  // fileID: "5285890807937512700",
                  controls: true,
                  muted: true,
                  // playbackRates: [0.5, 1, 1.25, 1.5, 2],
                  appID: appId, // 请传入点播账号的appID 必须
                  // width: utils.isMobile() ? 355 : 720, //视频的显示宽度
                  // height: utils.isMobile() ? 300 : 403, //视频的显示高度
                  definition: 30,
                  autoplay: false,
                  plugins: {
                    // ContinuePlay: {
                    // 	// 开启续播功能
                    // 	auto: true, //[可选] 是否在视频播放后自动续播
                    // 	text: "上次播放至 ", //[可选] 提示文案
                    // 	btnText: "恢复播放", //[可选] 按钮文案
                    // },
                  },
                  // controlBar: {
                  //   playbackRateMenuButton: false
                  // }
                });
                this.activePlaying.on("playing", () => {
                  this.$refs.xskjSwiper.swiper.autoplay.stop()
                })
                this.activePlaying.on("pause", () => {
                  this.$refs.xskjSwiper.swiper.autoplay.start()
                })

              }
            }
          );
        }
      );
    },
    showVideo(item) {
      console.log(item);
      if (item.tencent_vod_file_id && item.tencent_vod_app_id) {
        this.videoInfo = item,
          this.videoShow = true
      }
    },
    toDetail(item) {
      if (item) {
        this.goAppsDetailsBeforeLogin().then(() => {
          if (item.is_open_url == 2) {
            window.open(`${item.source_url}`, "_blank");
          } else {
            this.$router.push({
              path: `/${this.school_code}/kjqg/detail`,
              query: {
                id: item.id,
                column_id: item.column_id,
                columnPath: "zcqdkc",
              },
            });
          }
        });
      }
    },

  },
}
</script>

<style lang="less" scoped>
.zcqd-con {
  padding: calc(3.64vw + 42px) 0 50px;
  background-image: url("../../../assets/image/kjqg/common/common-bg.jpg");
  background-size: 100% auto;
  .zcqd-banner {
    width: 100%;
    margin-bottom: 40px;
  }
  .xskj-con {
    .xskj-title {
      width: 812px;
      height: 53px;
      background-image: url("../../../assets/image/kjqg/zcqdkc/xskj-title.png");
      background-size: cover;
      background-position: center;
      margin: 0 auto;
    }
    .xskj-top {
      width: 1200px;
      margin: 39px auto 0;
      display: flex;
      justify-content: space-between;
      .video-con {
        width: 890px;
        height: 552px;
        background: #ffffff;
        padding: 13px 13px 0;
        .video {
          width: 864px;
          height: 486px;
        }
        .video-title {
          font-weight: bold;
          font-size: 16px;
          color: #1f2734;
          text-align: center;
          margin-top: 14px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .top-con {
        width: 280px;
        height: 552px;
        position: relative;
        padding: 40px 10px;
        overflow: hidden;
        .swiper-button-prev.xskj {
          width: 280px;
          height: 28px;
          background-image: url("../../../assets/image/kjqg/index/xskj/xskj-swiper-btn.png");
          background-size: 100% auto;
          top: 0;
          left: 0;
          margin: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          opacity: 1;
          &:hover {
            &::before {
              background-image: url("../../../assets/image/kjqg/index/xskj/xskj-swiper-icon-hover.png");
            }
          }
          &::before {
            content: "";
            display: block;
            width: 19px;
            height: 13px;
            background-image: url("../../../assets/image/kjqg/index/xskj/xskj-swiper-icon.png");
            background-size: cover;
          }
        }
        .swiper-button-next.xskj {
          width: 280px;
          height: 28px;
          background-image: url("../../../assets/image/kjqg/index/xskj/xskj-swiper-btn.png");
          background-size: 100% auto;
          bottom: 0;
          left: 0;
          top: unset;
          margin: 0;
          transform: rotate(180deg);
          display: flex;
          justify-content: center;
          align-items: center;
          opacity: 1;
          &:hover {
            &::before {
              background-image: url("../../../assets/image/kjqg/index/xskj/xskj-swiper-icon-hover.png");
            }
          }
          &::before {
            content: "";
            display: block;
            width: 19px;
            height: 13px;
            background-image: url("../../../assets/image/kjqg/index/xskj/xskj-swiper-icon.png");
            background-size: cover;
          }
        }
        .swiper-container {
          height: 100%;

          .swiper-slide {
            cursor: pointer;
            &.active {
              border: 6px solid;
              border-image: linear-gradient(45deg, #157bf9, #174bc9) 10 10;
            }
            .item-cover {
              width: 100%;
              height: 100%;
              background-size: cover;
            }
          }
        }
      }
    }
    .xskj-list {
      display: flex;
      flex-wrap: wrap;
      width: 1200px;
      margin: 0 auto;
      justify-content: space-between;
      .xskj-item {
        width: 269px;
        margin-top: 36px;
        cursor: pointer;
        &.hide {
          display: none;
        }
        &:hover {
          .item-img {
            div {
              transform: scale(1.1);
              transition: all 0.3s;
            }
          }
          .item-title {
            .title-text {
              z-index: 11;
              position: absolute;
              overflow: unset;
              white-space: wrap !important;
              color: #1e63cb;
              width: 100%;
            }
          }
        }
        .item-img {
          width: 100%;
          height: 152px;
          overflow: hidden;
          background: #1e63cb;

          div {
            width: 100%;
            height: 100%;
            background-size: cover;
            background-position: center;
          }
        }
        .item-title {
          height: 40px;

          position: relative;
          .title-text {
            font-weight: bold;
            padding: 7px 13px;
            font-size: 16px;
            color: #333333;
            line-height: 26px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            background: #ffffff;
          }
        }
      }

      .bnkj-empty {
        width: 269px;
      }
    }
    .xskj-more {
      width: 140px;
      height: 40px;
      background: #ffffff;
      border-radius: 20px;
      margin: 28px auto 0;
      font-weight: 400;
      font-size: 16px;
      color: #1865e4;
      text-align: center;
      line-height: 40px;
      cursor: pointer;
      &::after {
        content: "";
        display: inline-block;
        width: 12px;
        height: 12px;
        background-image: url("../../../assets/image/kjqg/zcqdkc/more.png");
        background-size: cover;
        margin-left: 9px;
      }
    }
  }
  .zcyg-con {
    margin-top: 40px;
    .zcyg-title {
      width: 812px;
      height: 53px;
      background-image: url("../../../assets/image/kjqg/zcqdkc/zcyg-title.png");
      background-size: cover;
      background-position: center;
      margin: 0 auto;
    }
    .zcyg-main {
      margin: 60px auto 0;
      position: relative;
      width: 1180px;
      background: #fad393;
      border-radius: 0px 0px 16px 16px;
      padding-bottom: 14px;

      &::before {
        display: block;
        content: "";
        width: 1200px;
        height: 24px;
        position: absolute;
        left: 50%;
        top: -24px;
        transform: translateX(-50%);
        background: linear-gradient(
          0deg,
          #bcbcbe 0%,
          #d3d4d6 24%,
          #ffffff 100%
        );
        box-shadow: 0px 6px 8px 0px rgba(9, 25, 91, 0.14);
        border-radius: 12px;
      }
      .main-con {
        width: 1150px;
        margin: 0 auto;
        border-left: 6px solid #f9f2d7;
        border-right: 6px solid #f9f2d7;
        border-bottom: 6px solid #f9f2d7;
        border-radius: 0px 0px 16px 16px;
        background: #ffffff;
        padding: 50px 46px 40px 66px;
        display: flex;
        position: relative;
        &::before {
          display: block;
          content: "";
          width: 76px;
          height: 144px;
          background-image: url("../../../assets/image/kjqg/zcqdkc/zcyg-bg.png");
          background-size: cover;
          position: absolute;
          bottom: 0;
          left: 0;
        }
        .zcyg-categroy {
          width: 362px;
          position: relative;
          z-index: 1;
          margin-top: 17px;
          .categroy-item {
            width: 362px;
            height: 48px;
            position: relative;
            background: #dbeaff;
            margin-bottom: 10px;
            &:nth-child(1) {
              .item-text {
                &::before {
                  width: 18px;
                  height: 18px;
                  background-image: url("../../../assets/image/kjqg/zcqdkc/zcyg-categroy-1.png");
                  margin-right: 8px;
                }
              }
            }
            &:nth-child(2) {
              .item-text {
                &::before {
                  width: 16px;
                  height: 16px;
                  background-image: url("../../../assets/image/kjqg/zcqdkc/zcyg-categroy-2.png");
                  margin-right: 13px;
                }
              }
            }
            &:nth-child(3) {
              .item-text {
                &::before {
                  width: 13px;
                  height: 16px;
                  background-image: url("../../../assets/image/kjqg/zcqdkc/zcyg-categroy-3.png");
                  margin-right: 14px;
                  margin-left: 2px;
                }
              }
            }
            &:nth-child(4) {
              .item-text {
                &::before {
                  width: 16px;
                  height: 16px;
                  background-image: url("../../../assets/image/kjqg/zcqdkc/zcyg-categroy-4.png");
                  margin-right: 12px;
                }
              }
            }
            &:nth-child(5) {
              .item-text {
                &::before {
                  width: 12px;
                  height: 17px;
                  background-image: url("../../../assets/image/kjqg/zcqdkc/zcyg-categroy-5.png");
                  margin-right: 14px;
                  margin-left: 2px;
                }
              }
            }

            .item-text {
              padding-left: 38px;
              display: flex;
              align-items: center;
              width: 399px;
              height: 48px;
              font-weight: 400;
              font-size: 16px;
              color: #333333;
              line-height: 24px;
              transform: translateX(-20px);
              position: relative;
              cursor: pointer;
              // transition: all 0.3s;
              &::after {
                content: "";
                display: block;
                border-bottom: 24px solid transparent;
                border-top: 24px solid transparent;
                border-left: 24px solid 24px solid rgba(24, 101, 228, 0);
                border-right: 24px solid transparent;
                position: absolute;
                bottom: 0;
                top: 0;
                right: -48px;
              }
              &::before {
                content: "";
                display: inline-block;
                background-size: cover;
                background-position: center;
              }
            }
            &.active {
              &:nth-child(1) {
                .item-text {
                  &::before {
                    width: 18px;
                    height: 18px;
                    background-image: url("../../../assets/image/kjqg/zcqdkc/zcyg-categroy-1-hover.png");
                  }
                }
              }
              &:nth-child(2) {
                .item-text {
                  &::before {
                    width: 16px;
                    height: 16px;
                    background-image: url("../../../assets/image/kjqg/zcqdkc/zcyg-categroy-2-hover.png");
                  }
                }
              }
              &:nth-child(3) {
                .item-text {
                  &::before {
                    width: 13px;
                    height: 16px;
                    background-image: url("../../../assets/image/kjqg/zcqdkc/zcyg-categroy-3-hover.png");
                  }
                }
              }
              &:nth-child(4) {
                .item-text {
                  &::before {
                    width: 16px;
                    height: 16px;
                    background-image: url("../../../assets/image/kjqg/zcqdkc/zcyg-categroy-4-hover.png");
                  }
                }
              }
              &:nth-child(5) {
                .item-text {
                  &::before {
                    width: 12px;
                    height: 17px;
                    background-image: url("../../../assets/image/kjqg/zcqdkc/zcyg-categroy-5-hover.png");
                  }
                }
              }
              .item-text {
                background-color: rgba(24, 101, 228, 1);
                padding-left: 18px;
                font-weight: bold;
                font-size: 16px;
                color: #ffffff;
                &::after {
                  border-left: 24px solid rgba(24, 101, 228, 1);
                }
              }
            }
            &:hover {
              .item-text {
                background-color: rgba(24, 101, 228, 1);
                padding-left: 18px;
                font-weight: bold;
                font-size: 16px;
                color: #ffffff;
                &::after {
                  border-left: 24px solid rgba(24, 101, 228, 1);
                }
              }
              &:nth-child(1) {
                .item-text {
                  &::before {
                    width: 18px;
                    height: 18px;
                    background-image: url("../../../assets/image/kjqg/zcqdkc/zcyg-categroy-1-hover.png");
                  }
                }
              }
              &:nth-child(2) {
                .item-text {
                  &::before {
                    width: 16px;
                    height: 16px;
                    background-image: url("../../../assets/image/kjqg/zcqdkc/zcyg-categroy-2-hover.png");
                  }
                }
              }
              &:nth-child(3) {
                .item-text {
                  &::before {
                    width: 13px;
                    height: 16px;
                    background-image: url("../../../assets/image/kjqg/zcqdkc/zcyg-categroy-3-hover.png");
                  }
                }
              }
              &:nth-child(4) {
                .item-text {
                  &::before {
                    width: 16px;
                    height: 16px;
                    background-image: url("../../../assets/image/kjqg/zcqdkc/zcyg-categroy-4-hover.png");
                  }
                }
              }
              &:nth-child(5) {
                .item-text {
                  &::before {
                    width: 12px;
                    height: 17px;
                    background-image: url("../../../assets/image/kjqg/zcqdkc/zcyg-categroy-5-hover.png");
                  }
                }
              }
            }
          }
        }
        .zcyg-list {
          flex: 1;
          position: relative;
          min-height: 445px;
          background: #f9fafa;
          border-radius: 8px;
          border: 1px solid #efeeed;
          padding-left: 120px;
          padding-top: 20px;
          position: relative;
          &::before {
            content: "";
            display: block;
            position: absolute;
            top: 0;
            bottom: 0;
            left: 80px;
            height: 100%;
            width: 1px;
            border: 1px dashed #e6e9eb;
          }
          .zcyg-item {
            width: 510px;
            background: #fdf4e2;
            border-radius: 0 4px 4px 4px;
            border: 1px solid #d7cac3;
            padding: 12px 20px 15px 30px;
            position: relative;
            margin-bottom: 14px;
            cursor: pointer;
            &:nth-child(even) {
              border: 1px solid #c3cdd8;
              &::after {
                content: "";
                position: absolute;
                width: 10px;
                height: 10px;
                background: #7da0f8;
                top: -2px;
                left: -45px;
                border-radius: 50%;
              }
              background: #eef5fe;
              &::before {
                content: "";
                display: block;
                width: 14px;
                height: 16px;
                background-image: url("../../../assets/image/kjqg/zcqdkc/zcyg-item-b.png");
                position: absolute;
                top: -1px;
                // left: -1px;
                left: 0;
                transform: translateX(-100%);
                background-size: cover;
              }
            }
            &::before {
              content: "";
              display: block;
              width: 14px;
              height: 16px;
              background-image: url("../../../assets/image/kjqg/zcqdkc/zcyg-item-y.png");
              position: absolute;
              top: -1px;
              // left: -1px;
              left: 0;
              transform: translateX(-100%);
              background-size: cover;
            }
            &::after {
              content: "";
              position: absolute;
              width: 10px;
              height: 10px;
              background: #f6c079;
              top: -2px;
              left: -45px;
              border-radius: 50%;
            }
            .item-time {
              font-weight: bold;
              font-size: 14px;
              color: #4b3f26;
              line-height: 24px;
            }
            .item-title {
              font-weight: 400;
              font-size: 14px;
              color: #424446;
              line-height: 18px;
            }
          }
        }
      }
    }
  }
}
.spin-con {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  top: 0;
  z-index: 999;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>